import { Button } from "@components/button/button-untitledui";
import { CheckCircle } from "@untitledui/icons";

type InsightMarkResolvedButtonProps = {
	isResolved: boolean;
	isPending: boolean;
	disabled: boolean;
	onResolve: () => void;
};

export const InsightMarkResolvedButton = ({
	isResolved,
	isPending,
	disabled,
	onResolve,
}: InsightMarkResolvedButtonProps) => (
	<Button
		className="w-full shrink-0 sm:w-auto"
		color="secondary"
		iconLeading={
			<CheckCircle
				aria-hidden
				className="size-5 shrink-0 text-utility-success-700"
			/>
		}
		isDisabled={disabled || isPending || isResolved}
		isLoading={isPending}
		onClick={onResolve}
		showTextWhileLoading
		size="sm"
	>
		Já foi resolvido
	</Button>
);
